import { convertToHtml, getEditorStateFromHtml, hasContent } from 'hubspot-prosemirror/prosemirror/ProsemirrorUtils';
import useHubSpotRTE from 'hubspot-prosemirror/prosemirror/useHubSpotRTE';
import { useCallback, useEffect, useMemo, useState } from 'react';
import ProsemirrorRichTextEditor from '../components/common/ProsemirrorRichTextEditor';
import { RteEditorGlobalStyles } from '../styles/rteEditor';
import { getProseMirrorRteConfig } from '../utils/rteConfig';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const useProsemirrorEditor = ({
  mentionOwners,
  apiWrapper,
  portalId,
  openUrl,
  needToInit,
  initialValue,
  onChange,
  prosemirrorTrackerProperties,
  defaultComponent,
  snippetsCallback
}) => {
  const [proseMirrorRteConfig, setProseMirrorRteConfig] = useState(null);
  const [proseMirrorEditorState, setProseMirrorEditorState] = useHubSpotRTE(initialValue);
  const onProseMirrorContentChange = useCallback(newEditorState => {
    setProseMirrorEditorState(newEditorState);
    if (onChange) onChange(convertToHtml(newEditorState));
  }, [setProseMirrorEditorState, onChange]);
  const resetEditorState = useCallback(() => {
    setProseMirrorEditorState(getEditorStateFromHtml(''));
  }, [setProseMirrorEditorState]);

  // init rte config for html field types
  useEffect(() => {
    if (mentionOwners.length && portalId && needToInit) {
      setProseMirrorRteConfig(getProseMirrorRteConfig({
        mentionOwners,
        portalId,
        openUrl,
        apiWrapper,
        snippetsCallback
      }));
    }
  }, [mentionOwners, portalId, openUrl, apiWrapper, needToInit, snippetsCallback]);
  const blankComponent = useMemo(() => {
    if (proseMirrorRteConfig) return null;
    return defaultComponent !== null && defaultComponent !== void 0 ? defaultComponent : /*#__PURE__*/_jsx("span", {
      "data-test-id": "rich-text-editor-empty"
    });
  }, [defaultComponent, proseMirrorRteConfig]);
  const prosemirrorEditor = useMemo(() => {
    if (!proseMirrorRteConfig) return null;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx(ProsemirrorRichTextEditor, {
        rteConfig: proseMirrorRteConfig,
        setEditorState: onProseMirrorContentChange,
        editorState: proseMirrorEditorState,
        prosemirrorTrackerProperties: prosemirrorTrackerProperties
      }), /*#__PURE__*/_jsx(RteEditorGlobalStyles, {})]
    });
  }, [onProseMirrorContentChange, proseMirrorEditorState, proseMirrorRteConfig, prosemirrorTrackerProperties]);
  return {
    blankComponent,
    prosemirrorEditor,
    resetEditorState,
    hasContent: hasContent(proseMirrorEditorState)
  };
};
export default useProsemirrorEditor;